import { useTranslate } from 'react-admin';
import { Link } from 'react-router-dom';
import { Balcony, SquareFoot } from '@mui/icons-material';
import {
	Button,
	Card,
	CardActions,
	CardContent,
	CardMedia,
	List,
	ListItem,
	ListItemText,
	Typography
} from '@mui/material';
import { OBJECTS_TYPES } from '../../../constants';
import { OfficeType } from '../../../types';

export const OfficeCard = ({ data }: { data: OfficeType }) => {
	const translate = useTranslate();
	const { name, id, area, terrace, terrace_rent_area } = data;

	return (
		<Card sx={{ maxWidth: 210, display: 'flex', flexDirection: 'column' }}>
			<CardMedia
				component="img"
				height="140"
				image="https://t4.ftcdn.net/jpg/02/10/62/03/360_F_210620329_0le9P2aUC9LUqCyf6yqiV8MtVWrzGKi7.jpg"
				alt="office_image"
			/>
			<CardContent
				sx={{
					padding: 1
				}}
			>
				<Typography noWrap variant="h6" component="div">
					{name}
				</Typography>
				<List>
					<ListItem disablePadding={true}>
						<SquareFoot />
						<ListItemText
							slotProps={{
								primary: {
									fontSize: 16,
									fontWeight: 'medium'
								}
							}}
							sx={{ marginLeft: 1 }}
							primary={`${area} м²`}
						/>
					</ListItem>{' '}
					<ListItem disablePadding={true}>
						<Balcony />
						<ListItemText
							slotProps={{
								primary: {
									fontSize: 16,
									fontWeight: 'medium'
								}
							}}
							sx={{ marginLeft: 1 }}
							primary={`Тераса: ${terrace ? `Так (${terrace_rent_area} м²)` : 'Ні'}`}
						/>
					</ListItem>
				</List>
			</CardContent>
			<CardActions
				sx={{
					marginTop: 'auto'
				}}
			>
				<Button
					component={Link}
					to={`/objects/${OBJECTS_TYPES.OFFICES}/show/${id}`}
					size="small"
				>
					{translate('list.details')}
				</Button>
			</CardActions>
		</Card>
	);
};
